module.exports = __webpack_public_path__ + "gamecode/img/ztmslgme_favicon.png?8a24ee15";